<template>
    <p>
        <strong>Ampelsystem:</strong>
        <span class="c-ranking c-ranking--red"></span> in mehreren Kolonnen eingeplant
    </p>
</template>
<script>
    export default {
        name: 'KolonneSettingsCrudVehiclesRankingLegend'
    }
</script>
